export const getRandomId = () => {
  return String(window.crypto.getRandomValues(new Uint32Array(1))[0]);
};
